import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LoadCatalogService } from './load-catalog.service';
import { LoadCatalogInitialState, LoadCatalogFetch } from './load-catalog.actions';
import { NotificationService } from '../../../../../../common/services';
import { LoadPrimary } from '../../models';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../../common/models';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type LoadCatalogStateModel = ListServerPaginationStateModel<LoadPrimary>;

const initialState: LoadCatalogStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<LoadCatalogStateModel>({
  name: 'loadCatalog',
  defaults: initialState,
})
@Injectable()
export class LoadCatalogState {
  constructor(private loadCatalogService: LoadCatalogService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: LoadCatalogStateModel): LoadCatalogStateModel {
    return state;
  }

  @Selector()
  static getItems(state: LoadCatalogStateModel): LoadPrimary[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: LoadCatalogStateModel): boolean {
    return state.loaded;
  }

  @Action(LoadCatalogFetch)
  getLoadList(
    ctx: StateContext<LoadCatalogStateModel>,
    { payload }: LoadCatalogFetch,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.loadCatalogService.getLoadCatalog(payload).pipe(
      map((loadCatalog: LoadCatalogStateModel) => {
        ctx.patchState({ ...loadCatalog, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(LoadCatalogInitialState)
  setInitialState(ctx: StateContext<LoadCatalogStateModel>): void {
    ctx.setState(initialState);
  }
}
